import React, { useEffect } from 'react'
import { signinRedirectCallback } from 'services/userService'
import { useNavigate } from 'react-router-dom'

function SigninOidc() {
  const history = useNavigate()
  useEffect(() => {

    caches.log('SigninOidc...');

    async function signinAsync() {
      await signinRedirectCallback()
      history('/')
    }
    signinAsync()
  }, [history])

  return (
    <div>
      Redirecting...
    </div>
  )
}

export default SigninOidc
